import type { FC, ReactNode } from 'react'

import { ButtonLink } from '@/components/generals/button-link'
import { SectionLabel } from '@/components/generals/section-label'
import { processSteps } from '@/constants/content'

export const Process: FC = (): ReactNode => {
    return (
        <section id='process' className='py-20 md:py-32'>
            <div className='page-container grid gap-12 md:grid-cols-12 md:gap-8'>
                <div className='md:sticky md:top-28 md:col-span-5 md:self-start'>
                    <SectionLabel className='text-muted-foreground'>
                        Process
                    </SectionLabel>

                    <h2 className='mt-5 text-balance font-heading text-[clamp(2.75rem,6vw,5.75rem)] font-semibold leading-[0.92] tracking-[-0.045em]'>
                        From first call to <em className='font-serif font-normal italic tracking-[-0.02em] text-brand'>launch day</em>
                    </h2>

                    <p className='mt-6 max-w-md text-lg leading-relaxed text-muted-foreground'>
                        Clear steps, honest timelines and one person you can always reach. Most projects take between six and ten weeks.
                    </p>

                    <ButtonLink href='#contact' variant='outline' className='mt-8'>
                        Plan your project
                    </ButtonLink>
                </div>

                <ol className='grid gap-5 md:col-span-7 md:col-start-6 lg:col-span-6 lg:col-start-7'>
                    {processSteps.map((step, index) => (
                        <li key={step.title} className='md:sticky' style={{ top: `${6.5 + index * 1.25}rem` }}>
                            <article className='rounded-2xl border border-foreground/10 bg-card p-7 shadow-[0_24px_60px_-40px_rgba(18,17,16,0.4)] md:p-10'>
                                <div className='flex items-start justify-between gap-6'>
                                    <span className='font-heading text-7xl font-semibold leading-none tracking-[-0.06em] text-brand md:text-8xl'>
                                        {String(index + 1).padStart(2, '0')}
                                    </span>

                                    <span className='rounded-full bg-muted px-3 py-1.5 font-mono text-[11px] font-medium uppercase tracking-[0.14em] text-muted-foreground'>
                                        {step.timing}
                                    </span>
                                </div>

                                <h3 className='mt-8 font-heading text-3xl font-semibold tracking-[-0.03em] md:text-4xl'>
                                    {step.title}
                                </h3>

                                <p className='mt-3 text-lg leading-relaxed text-muted-foreground'>
                                    {step.description}
                                </p>
                            </article>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    )
}
